export enum REPORT_LINK_OPTIONS {
    PDF = 0,
    PPT = 1,
}
